module.exports = __webpack_public_path__ + "static/img/promotion1.f89d0192.png";